exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".description[data-v-69e7bffe]{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-box-align:center;-webkit-align-items:center;-ms-flex-align:center;align-items:center;grid-gap:8px;gap:8px}@media (min-width:769px){.description .hint[data-v-69e7bffe]{-webkit-transform:translateX(-69%);-ms-transform:translateX(-69%);transform:translateX(-69%)}}@media (max-width:768px){.orders-checked .wrap-row .price[data-v-69e7bffe]{font-size:16px}}", ""]);

// exports
